import { graphql } from 'react-relay';
export const CommentsPanelQuery = graphql`
	query CommentsPanelQuery($pageId: ID!) {
		comments(pageId: $pageId, type: UNRESOLVED, depth: ROOT, first: 50) {
			nodes {
				id
				body(representation: ATLAS_DOC_FORMAT) {
					value
				}
				contentStatus
				createdAt {
					value
				}
				createdAtNonLocalized
				links {
					webui
					editui
				}
				location {
					type
					... on InlineComment {
						inlineMarkerRef
						inlineText
						inlineResolveProperties {
							resolved
							isDangling
							resolvedFriendlyDate
							resolvedTime
							resolvedUser
						}
					}
					... on FooterComment {
						commentResolveProperties {
							resolved
							resolvedFriendlyDate
							resolvedTime
							resolvedUser
						}
					}
				}
				parentId
				permissions {
					isEditable
					isRemovable
					isResolvable
				}
				version {
					by {
						displayName
					}
					when
					number
				}
				author {
					displayName
					profilePicture {
						path
					}
					permissionType
					... on KnownUser {
						accountId
					}
				}
				createdAt {
					value
				}
				createdAtNonLocalized
				replies {
					id
					body(representation: ATLAS_DOC_FORMAT) {
						value
					}
					contentStatus
					createdAt {
						value
					}
					createdAtNonLocalized
					links {
						webui
						editui
					}
					location {
						type
						... on InlineComment {
							inlineMarkerRef
							inlineText
							inlineResolveProperties {
								resolved
								isDangling
								resolvedFriendlyDate
								resolvedTime
								resolvedUser
							}
						}
						... on FooterComment {
							commentResolveProperties {
								resolved
								resolvedFriendlyDate
								resolvedTime
								resolvedUser
							}
						}
					}
					parentId
					permissions {
						isEditable
						isRemovable
						isResolvable
					}
					version {
						by {
							displayName
						}
						when
						number
					}
					author {
						displayName
						profilePicture {
							path
						}
						permissionType
						... on KnownUser {
							accountId
						}
					}
					createdAt {
						value
					}
					createdAtNonLocalized
				}
			}
			totalCount
		}
	}
`;
